module.exports = __webpack_public_path__ + "img/admission-3.76c2a490.jpg";